import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchProjects = () => api.get("/projects").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const createQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);
export const fetchQuotes = () => api.get("/quotes").then((r) => r.data);
